import { Box, TextField, Stack, FormHelperText } from '@mui/material';
import { useRef } from 'react';

interface DailyTimeRangeInputProps {
  value: string;
  onChange: (newValue: string) => void;
}

interface HTMLInputWithPicker extends HTMLInputElement {
  showPicker: () => void;
}

function timeToMinutes(time: string) {
  const [hours, minutes] = time.split(':').map(Number);
  return hours * 60 + minutes;
}

export default function DailyTimeRangeInput({ value, onChange }: DailyTimeRangeInputProps) {

  const parts = value?.split('-') ?? [];
  const startTime = parts[0] || '';
  const endTime = parts[1] || '';
  const startInputRef = useRef<HTMLInputElement>(null);
  const endInputRef = useRef<HTMLInputElement>(null);

   const getValidationError = (value: string) => {
    if (!value) return null;
    const [start, end] = value.split('-');
    if (!start || !end) return null;

    const startMinutes = timeToMinutes(start);
    const endMinutes = timeToMinutes(end);

    if (startMinutes >= endMinutes) {
      return 'Start time must be before end time.';
    }

    return null;
  };

  const error = getValidationError(value);

  const handleValidatedChange = (newStart: string, newEnd: string) => {
    onChange(`${newStart}-${newEnd}`);
  };

  return (
    <Box>
      <Stack direction="row" spacing={3} alignItems="center">
        <Box
          sx={{ width: '100%' }}
          onClick={() => (startInputRef.current as HTMLInputWithPicker)?.showPicker()}
        >
          <TextField
            label=""
            type="time"
            size="small"
            value={startTime}
            inputRef={startInputRef}
            onChange={(e) => handleValidatedChange(e.target.value, endTime)}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              style: { cursor: 'pointer' }
            }}
            className='w-100'
          />
        </Box>
        <Box
          sx={{ width: '100%' }}
          onClick={() => (endInputRef.current as HTMLInputWithPicker)?.showPicker()}
        >
          <TextField
            label=""
            type="time"
            value={endTime || ''}
            inputRef={endInputRef}
            onChange={(e) => handleValidatedChange(startTime, e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              style: { cursor: 'pointer' }
            }}
            className='w-100'
          />
        </Box>
      </Stack>
      {error && (
        <FormHelperText error>{error}</FormHelperText>
      )}
    </Box>
  );
}
